exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usc-bi {\r\n    background-color: black;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-bi-header/usc-bi-header.component.css
// module id = ../../../../../src/app/components/usc-bi/usc-bi-header/usc-bi-header.component.css
// module chunks = main